/**
 * 平台商店榜单映射配置
 * @author lv.chen
 * @description 定义各个平台支持的商店榜单类型
 */
export const PLATFORM_STORE_TOPS_MAP: Record<IPlatform, string[]> = {
  steam: ['steam top sellers'],
  epic: ['epic top sellers', 'epic top popular'],
  xbox: ['xbox new release', 'xbox upcoming', 'xbox most played', 'xbox best rated', 'xbox top free', 'xbox top paid'],
  playstation: [
    'playstation best selling',
    'playstation most downloaded',
    'playstation new games',
    'playstation coming soon',
    'playstation indies games',
    'playstation free to play',
  ],
  nintendo: ['nintendo best sellers', 'nintendo new release', 'nintendo coming soon'],
};

/**
 * 获取指定平台支持的榜单列表
 * @author lv.chen
 * @param platform 平台名称
 * @returns 该平台支持的榜单数组
 */
export const getPlatformStoreTops = (platform: IPlatform): string[] => {
  return PLATFORM_STORE_TOPS_MAP[platform] ?? [];
};

/**
 * 获取所有支持的平台列表
 * @author lv.chen
 * @returns 所有支持的平台名称数组
 */
export const getSupportedPlatforms = (): IPlatform[] => {
  return Object.keys(PLATFORM_STORE_TOPS_MAP) as IPlatform[];
};

/**
 * 检查平台是否被支持
 * @author lv.chen
 * @param platform 平台名称
 * @returns 是否支持该平台
 */
export const isPlatformSupported = (platform: IPlatform): boolean => {
  return Reflect.has(PLATFORM_STORE_TOPS_MAP, platform);
};

/**
 * 根据平台配置获取商店榜单映射
 * @author lv.chen
 * @param platforms 平台配置，可以是单个平台或平台数组
 * @returns 平台到榜单数组的映射
 */
export const getStoreTopsMapByPlatforms = (platforms?: IPlatformConfig | null): Record<IPlatform, string[]> => {
  if (!platforms) {
    return {} as unknown as Record<IPlatform, string[]>;
  }

  // 统一转换为数组处理
  const platformArray: IPlatform[] = Array.isArray(platforms) ? platforms : [platforms];

  if (platformArray.length === 0) {
    return {} as unknown as Record<IPlatform, string[]>;
  }

  return platformArray.reduce<Record<IPlatform, string[]>>((result, platform) => {
    result[platform] = getPlatformStoreTops(platform);
    return result;
  }, {} as unknown as Record<IPlatform, string[]>);
};
